import { render, staticRenderFns } from "./AtomCheckBox2.vue?vue&type=template&id=25a41ebc&scoped=true&"
import script from "./AtomCheckBox2.vue?vue&type=script&lang=ts&"
export * from "./AtomCheckBox2.vue?vue&type=script&lang=ts&"
import style0 from "./AtomCheckBox2.vue?vue&type=style&index=0&id=25a41ebc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a41ebc",
  null
  
)

export default component.exports